/*  subscription-tag.js  ─ Views / Baseline
    ▸ Marque le panier quand un abonnement PayWhirl est présent
    ▸ Écrit deux cart attributes lisibles par Shopify Flow / webhooks
    v2025-06-26-b  */

(() => {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Réglages                                                            */
  /* ------------------------------------------------------------------ */
  const DEBUG        = true;                          // logs console
  const GENERIC_TAG  = 'ABONNEMENT_EN_COURS';         // tag « abo en cours »
  const PLAN_MAP     = {                              // selling_plan_id ➜ tag
    '689781473612': 'SUB_1Y_PREPAID',
    '689781506380': 'SUB_2Y_PREPAID'
  };

  /* ------------------------------------------------------------------ */
  /* Helpers Ajax                                                        */
  /* ------------------------------------------------------------------ */
  const getCart = () => fetch('/cart.js').then(r => r.json());

  const updateAttributes = (attrs) =>
    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ attributes: attrs })
    });

  const log = (...args) => DEBUG && console.info('[subscription-tag]', ...args);

  /* ------------------------------------------------------------------ */
  /* Extraction des selling_plan_id                                      */
  /* ------------------------------------------------------------------ */
  const extractPlanTags = (cart) => {
    const tags = new Set();

    cart.items.forEach(item => {
      let planId = null;

      /* 1. cas normal */
      if (item.selling_plan_allocation?.selling_plan_id) {
        planId = String(item.selling_plan_allocation.selling_plan_id);
      }

      /* 2. fallback : PayWhirl range parfois le plan dans « properties » */
      if (!planId && item.properties) {
        for (const [k, v] of Object.entries(item.properties)) {
          if (k.toLowerCase().includes('selling_plan') && v) {
            planId = String(v);
            break;
          }
        }
      }

      if (planId && PLAN_MAP[planId]) {
        tags.add(PLAN_MAP[planId]);
      }
    });

    return [...tags];
  };

  /* ------------------------------------------------------------------ */
  /* Mise à jour du panier                                               */
  /* ------------------------------------------------------------------ */
  const tagCart = async () => {
    try {
      const cart     = await getCart();
      const planTags = extractPlanTags(cart);

      if (!planTags.length) {
        log('aucun selling_plan_id trouvé — skip');
        return;
      }

      const newAttrs = {
        ...(cart.attributes || {}),
        ABO_STATUS : GENERIC_TAG,
        ABO_TAGS   : planTags.join(', ')
      };

      /* Évite les requêtes inutiles */
      const identical =
        cart.attributes?.ABO_STATUS === newAttrs.ABO_STATUS &&
        cart.attributes?.ABO_TAGS   === newAttrs.ABO_TAGS;

      if (identical) {
        log('attributs déjà à jour — skip');
        return;
      }

      await updateAttributes(newAttrs);
      log('attributs mis à jour', newAttrs);

    } catch (e) {
      console.error('[subscription-tag] ERREUR', e);
    }
  };

  /* ------------------------------------------------------------------ */
  /* Bootstrap & hooks Ajax (Baseline)                                   */
  /* ------------------------------------------------------------------ */

  /* 1. Au chargement initial */
  document.addEventListener('DOMContentLoaded', tagCart);

  /* 2. Évènements Ajax du thème Baseline */
  [
    'cart:refresh',          // déclenché par Baseline après chaque update
    'theme:cart:change',     // déclenché par drawer-cart
    'ajaxProduct:added'      // fallback générique PayWhirl / themes
  ].forEach(evt => document.addEventListener(evt, tagCart));

  /* 3. Filet de sécurité : re-scan 4 s après un add-to-cart */
  let debounceId = null;
  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart/add"]')) {
      clearTimeout(debounceId);
      debounceId = setTimeout(tagCart, 4000);
    }
  });
})();